import { BoundingBox } from './bounding-box';

export interface EditedPhotoData {
    photoId: string;
    rotation?: number;
    crop?: BoundingBox;
    maxBoundingBox?: BoundingBox;
}
